module.exports = __webpack_public_path__ + "static/media/spaceship.3e41fa7a.png";